export default function InactiveKioskLabel() {
  return (
    <span>
      The selected organization does not have the Kiosk service activated
    </span>
  )
}
